import * as React from "react"
import { Link as RRLink } from "react-router-dom"

import {
    Container,
    Grid,
    GridRow,
    GridColumn,
    Segment,
    Header,
    Divider
} from "semantic-ui-react"

import "./index.css"

interface Props {
    preface: string
    header: string
    link: string
    items: Item[]
}

interface Item {
    link?: string | null
    content: any
}

export default class Box extends React.Component<Props> {
    render() {
        const linkItems = this.props.items.map((it, i) => {
            if (it.link) {
                return <Link key={i} to={it.link}><li>{it.content}</li></Link>
            } else {
                return <li>{it.content}</li>
            }
        })

        return (
            <div className="Box">
                <Link to={this.props.link}>
                    <div>
                        <p>{this.props.preface}</p>
                        <h1>{this.props.header}</h1>
                    </div>
                </Link>
                <ul>
                    {linkItems}
                </ul>
            </div>
        );
    }
}

interface LinkProps {
    to: string
}

class Link extends React.Component<LinkProps> {
    render() {
        const to = this.props.to
        const isExternal =  /^https?:\/\//.test(to)

        if (isExternal) {
            return <a href={to}>{this.props.children}</a>
        } else {
            return <RRLink to={to}>{this.props.children}</RRLink>
        }
    }
}


// WEBPACK FOOTER //
// ./src/modules/frontpage/Box/index.tsx